import React, { useState } from 'react';

import CommonService from '../../../../services/commonService';
import { connect } from 'react-redux';
import getIcons from '../../functions/getIcons/getIcons';

// import * as actions from './redux/actions';

const ThemeThreeHeader = ({ children, history, operator, loginData, t, onMyAccountClick }) => {
	operator = operator || CommonService.getLocal('op') || {};



	return (
		operator && (
			<div className="themes-theme-three-header">
				{operator && operator.show_top_header ? <TopHeader operator={operator} /> : ''}
				<div
					style={{
						background:
							operator && operator.color_codes && operator.color_codes.header_color
								? operator.color_codes.header_color
								: '',
					}}
					className="d-flex-c"
				>
					<div className="new-container  flex">
						<a href="/">
							<img
								src={operator && operator.header_logo ? operator.header_logo : ''}
								alt=""
								className="logo2"
								id="main-logo"
							// style={{ height: 58, width: 'auto' }}
							/>
						</a>

						<div div className='d-flex-c'>
							<style>
								.themes-theme-three-header .header_link{'{'}
								border-bottom: 2px solid{' '}
								{operator && operator.operator_name === "basetorres" && operator.color_codes && operator.color_codes.primary_color
									? operator.color_codes.primary_color
									: ''}{' '}
								font-weight:600 !important ;
							</style>
							<style>
								.themes-theme-three-header .header_link:hover {'{'}
								border-bottom: 2px solid{' '}
								{operator && operator.color_codes && operator.color_codes.tertiary_color
									? operator.color_codes.tertiary_color
									: ''}{' '}
								!important ; font-weight: 600;
								{'}'}
								.nav-section.home-nav-section.common-top-strip.header-box + * {'{'}
								margin-top:270px;
								{'}'}
								.nav-section.home-nav-section.common-top-strip.header-box.payments-page-header + *{' '}
								{'{'}
								margin-top:95px;
								{'}'}
							</style>


							{operator &&
								operator.show_header_links &&
								operator.header_links.map((val, i) => {
									if (Object.keys(val)[0] === 'Políticas de privacidad') {
										if (operator.operator_name === 'arzola') {
											return (
												<span
													key={i}
													className="header_link f-13 pointer"
													style={{
														color: operator.color_codes
															? operator.color_codes.secondary_text_color
															: '',
													}}
													onClick={() => {
														history.push(Object.values(val)[0]);
													}}
												>
													{Object.keys(val)}
												</span>
											);
										} else {
											return null;
										}
									}

									// return (
									// 	<span
									// 		key={i}
									// 		className={`header_link f-13 pointer  ${window.location.pathname ==
									// 			Object.values(val) && operator.operator_name == "busnorte" ? "new-bold-font" : ""}`}
									// 		style={{
									// 			color: operator.color_codes
									// 				? operator.color_codes.secondary_text_color
									// 				: '',

									// 			borderBottom:
									// 				window.location.pathname == Object.values(val)[0] &&
									// 					operator &&
									// 					operator.color_codes &&
									// 					operator.color_codes.tertiary_color
									// 					? operator && operator.operator_name === 'busnorte'
									// 						? `2px solid ${operator.color_codes.tertiary_color}`
									// 						: ''
									// 					: '',

									// 		}}
									// 		onClick={() => {
									// 			history.push(Object.values(val)[0]);
									// 		}}
									// 	>
									// 		{Object.keys(val)}
									// 	</span>
									// );
									return (
										<span
											key={i}
											className={`header_link f-13 pointer 
														${window.location.pathname == Object.values(val)[0] && operator.operator_name == "busnorte" ? "new-bold-font" : ""} 
														${window.location.pathname == Object.values(val)[0] && operator && operator.operator_name == "basetorres" ? "selectedline" : ""}`}
											style={{
												color: operator.color_codes
													? operator.color_codes.secondary_text_color
													: '',

												borderBottom:
													window.location.pathname == Object.values(val)[0] &&
														operator &&
														operator.color_codes &&
														operator.color_codes.tertiary_color
														? operator && operator.operator_name === 'busnorte'
															? `2px solid ${operator.color_codes.tertiary_color}`
															: ''
														: '',
											}}
											onClick={() => {
												history.push(Object.values(val)[0]);
											}}
										>
											{Object.keys(val)}
										</span>
									);



								})}


							{operator && operator.has_user_account && (
								<span>
									<div className="my-account-top font10">
										<a onClick={onMyAccountClick}>
											{CommonService.isLoggedIn(loginData) && loginData.image_link ? (
												<div className="dp-image-top">
													<img src={loginData.image_link} alt="DIS" />
												</div>
											) : (
												<div
													className={
														'menu-profile-icon-stripe circular-icon-stripe profile-circular-icon '
													}
												>
													<img
														src={getIcons('userIcon', operator)}
														// src="/static/images/user_red_dot.svg"
														alt={t('TRANSLATIONS.USER_DOT')}
													/>
												</div>
											)}
											{/* {CommonService.isLoggedIn(this.props.common.loginData)
                          ? CommonService.capitalize(this.props.common.loginData.name)
                          : t('HOME.MY_ACCOUNT')} */}
										</a>
										{/* {this.state.showMyAccountDropDown ? this.renderMyAccountDropdown(t) : null} */}
									</div>
								</span>
							)}
						</div>

					</div>
				</div>

				{children}
			</div >
		)
	);
};

const TopHeader = ({ operator }) => {
	return (
		<div
			className="d-flex-c p5"
			style={{
				background: operator && operator.color_codes && operator.color_codes.sub_header_color,
				color: operator && operator.color_codes && operator.color_codes.secondary_text_color,
			}}
		>
			<div className="new-container d-flex-end " style={{ paddingRight: '10px' }}>
				{operator.operator_name === 'aeroquinta' || operator.operator_name === 'arzola' && operator.phone_number && (
					<span className="d-flex-c email">
						<img src={getIcons('phone', operator)} alt="Phone Icon" className="top_icon" />
						{operator.phone_number || 'N/A'}
					</span>
				)}

				{operator && operator.email && operator.operator_name === "busnorte" ? (
					<div className='d-flex-c pr-20 green-color'>
						<span className={operator && operator.operator_name == "busnorte" ? "d-flex-c  email side-menu-new-bold-font" : "d-flex-c  email"}>
							<img
								src={getIcons('phone', operator)}
								alt="DIS"
								className="top_icon"
							// id="main-logo"
							// alt={this.props.t('TRANSLATIONS.MAIN_LOGO')}
							/>

							{operator.phone_number ? operator.phone_number : 'N/A'}
						</span>
						<span className={operator && operator.operator_name == "busnorte" ? "d-flex-c  email side-menu-new-bold-font" : "d-flex-c  email"}>
							<img
								src={getIcons('email', operator)}
								alt="DIS"
								className="top_icon"
							// id="main-logo"
							// alt={this.props.t('TRANSLATIONS.MAIN_LOGO')}
							/>

							{operator.email ? operator.email : 'N/A'}
						</span>		</div>
				) : (
					<span className="d-flex-c  email">
						<img
							src={getIcons('email', operator)}
							alt="DIS"
							className="top_icon"
						// id="main-logo"
						// alt={this.props.t('TRANSLATIONS.MAIN_LOGO')}
						/>
						{operator.email ? operator.email : 'N/A'}
					</span>
				)

				}
			</div>

		</div >
	);
};

/* istanbul ignore next */
function mapStateToProps(state) {
	return {
		themes: state.themes,
	};
}

// /* istanbul ignore next */
// function mapDispatchToProps(dispatch) {
//   return {
//     actions: bindActionCreators({ ...actions }, dispatch),
//   };
// }

export default connect(mapStateToProps, {})(ThemeThreeHeader);



// WEBPACK FOOTER //
// ./src/features/themes/ThemeThree/common/ThemeThreeHeader.js